import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
import '../../../../styles/assets/css/admin/list1.css'
import { loadLocationWithMessage } from '../../../../actions/location'

import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import TabContext from '@material-ui/lab/TabContext'
import TabList from '@material-ui/lab/TabList'
import TabPanel from '@material-ui/lab/TabPanel'

import CoursesAssign from "./resources/courses_assign"
import CourseProgress from "./resources/course_progress"
import WorksheetsAssign from "./resources/worksheets_assign"
import SelfGuideAssign from "./resources/self_guide_assign"
//import ResourcesAssign from "./resources/resources_assign"

class TabCourses extends Component {
  constructor() {
      super();
      this.state = {
          status: false,
          message: '',
          tab_status: '1',
          uid: 0,
          pid: 0,
          doctor: 0,
          type: 0,
          date: '',
          time: '',
          duration: 0,
          patient_status: 0,
      }
  }

  componentDidMount() {
    if(this.props.match.params.secondtab) {
      this.setState({
        tab_status: this.props.match.params.secondtab,
      })
    }
  }

  handleTabChange = (event, newValue) => {
    this.setState({
      tab_status: newValue,
    })
  }

  render() {

    return (
      <div className="admin_make_appointment">
        <div className="row">
          <div className="small-12 columns tab_data1 less_space1">
            <TabContext value={this.state.tab_status}>
              <AppBar position="static">
                <TabList onChange={this.handleTabChange} aria-label="simple tabs example">
                  <Tab label="MBCT/Assign" value="1" />
                  <Tab label="MBCT/Progress" value="2" />
                  <Tab label="Worksheets/Assign" value="3" />
                  <Tab label="Self-Guided Programs/Assign" value="4" />
                  {/*<Tab label="Resources/Assign" value="5" />*/}
                </TabList>
              </AppBar>
              <TabPanel value="1" index={1} >
              {this.state.tab_status == 1 && <CoursesAssign />}
              </TabPanel>
              <TabPanel value="2" index={2} >
              {this.state.tab_status == 2 && <CourseProgress />}
              </TabPanel>
              <TabPanel value="3" index={3} >
              {this.state.tab_status == 3 && <WorksheetsAssign />}
              </TabPanel>
              <TabPanel value="4" index={4} >
              {this.state.tab_status == 4 && <SelfGuideAssign />}
              </TabPanel>
              {/*<TabPanel value="5" index={5} >
              {this.state.tab_status == 5 && <ResourcesAssign />}
              </TabPanel>*/}
            </TabContext>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log('AddPatient STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('AddPatient mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(TabCourses)
